import { css } from '@emotion/react';
import NvDropdown, {
  NvDropdownButtonStyle,
  NvDropdownCheckbox,
  NvDropdownHeader,
  NvDropdownRadio,
} from 'shared/components/inputs/nv-dropdown';

export type NvFilterProps = {
  title: string;
  /** Stable identifier used as the React key. Use this when the title is dynamic
   * (e.g. includes a count) to prevent the dropdown from remounting on change. */
  filterKey?: string;
  selected: boolean;
  items: Array<NvDropdownHeader | NvDropdownCheckbox | NvDropdownRadio>;
  onToggle?: (isOpen: boolean) => void;
  className?: string;
};

export const NvFilter = ({ title, selected, items, onToggle, className }: NvFilterProps) => {
  const styles = css`
    .nv-dropdown {
      display: inline-flex;
    }
  `;

  return (
    <div css={styles} className={`nv-filter${className ? ` ${className}` : ''}`}>
      <NvDropdown
        showSelectedIndicator
        pill
        title={title}
        altLabel={title}
        buttonStyle={NvDropdownButtonStyle.FORM_SMALL}
        buttonClass={selected && 'selected'}
        items={items}
        menuClassName='filter-menu'
        toggleDataQa={title.split(' ').join('_').toUpperCase()}
        onToggle={onToggle}
      />
    </div>
  );
};

export default NvFilter;
